import React from 'react'
import {
  Box, Anchor, RadioButton, Text,
} from '@usap/uicomponents'
import { Heading5 } from '../../../../common/heading'
import useWmoEnabled from '@usap/carparts/src/shared/hooks/useWmoEnabled'
import FirstSelectReasonWMO from './FirstSelectReasonWMO'

const FirstSelectReason = props => {
  const { firstStep, onChangeReason, isDesktop } = props

  const isWmoEnabled = useWmoEnabled()

  if(isWmoEnabled) {
    return (
      <FirstSelectReasonWMO {...props} />
    )
  }

  return (
    <Box width="large" alignContent="center" alignSelf="center">
      <Heading5
        key={`${firstStep.id}-0`}
        title={firstStep.title}
        size={isDesktop ? 'medium' : 'small'}
        color="#000"
        style={{ fontSize: '14px', fontWeight: 700 }}
        margin={{ bottom: '8px', top: '15px' }}
      />
      <Box
        width="large"
        alignContent="start"
        alignSelf="start"
        pad="medium"
        style={{ border: '1px solid #E0E0E0', borderRadius: '6px' }}
      >
        <RadioButton
          value={firstStep.id}
          name={firstStep.id}
          checked
          disable
          readOnly
          label={(
            <Text size="small" margin={{ left: 'xsmall' }} style={{ fontSize: '14px', fontWeight: 500 }}>
              {firstStep.label}
            </Text>
          )}
        />
      </Box>
      <Box
        width="large"
        alignContent="start"
        alignSelf="start"
        pad={{ left: '16px' }}
      >
        <Anchor
          margin={{ top: 'small' }}
          onClick={() => onChangeReason()}
          size="large"
          style={{ textDecoration: 'none' }}
          alignSelf="start"
          justify="center"
          label={(
            <Text size="large" style={{ fontWeight: 'normal', fontSize: 14 }}>
              Change
            </Text>
          )}
        />
      </Box>
    </Box>
  )
}

export default FirstSelectReason
